import React from "react";
import { useNavigate } from "@reach/router";
import Button from "../../basic/Button";
import { T } from "../../../hooks/useLanguage";
import "./styles/style.scss";

import { getRadioEntryPath } from "../../../features/entryFlow/entryIntentStorage";

const NotFound = () => {
  const navigate = useNavigate();
  const radioEntryPath = getRadioEntryPath();

  return (
    <div className="container not-found">
      <div className="not-found__content">
        <h1 className="not-found__code">404</h1>
        <h2 className="not-found__title">
          <T>notfound.title</T>
        </h2>
        <p className="not-found__message">
          <T>notfound.message</T>
        </p>
        <Button 
          block 
          className="success" 
          onClick={() => navigate(radioEntryPath || "/")}
        >
          <T>{radioEntryPath ? "sonicbox.gotoradio" : "notfound.home"}</T>
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
